import {useState} from 'react'

import ExampleCode from './ExampleCode'
import {Tabs} from '../Tabs'

import type {Tab} from '../Tabs'

type Props<T> = {
    title: string
    tabs: readonly Tab<T>[]
    getHtml: (tab: Tab<T>) => string
}

export default function ApiExample<T>({title, tabs, getHtml}: Props<T>) {
    const [activeTab, setActiveTab] = useState(tabs[0])

    return <div className='row row_col row_gap-2'>
        <h5>{title}</h5>
        <div className='row row_col row_gap-0'>
            <Tabs
                tabs={tabs}
                onTabClick={setActiveTab}
                value={activeTab.value}
                className='tabs_rounded'
                tabClassName='api-tab'
            />
            <ExampleCode>
                <div dangerouslySetInnerHTML={{__html: getHtml(activeTab)}}/>
            </ExampleCode>
        </div>
    </div>
}
